import React from 'react';
import { ShimmeringLoaderBar } from '@kyruus/loaders-and-spinners';
import {
  DesktopShimmerLoader,
  LoadingBookingOptionsMessage,
  LoadingCard
} from './styles';
import { FormattedMessage } from '@kyruus/intl';
import { messages } from '@kyruus/provider-components';

export const LoadingAppointmentAside = ({
  isLoading
}: {
  isLoading: boolean;
}) => {
  const loadingMessage = isLoading
    ? messages.ariaLiveLoadingBookingInformation
    : messages.ariaLiveLoadingBookingInformationComplete;
  return (
    <>
      <LoadingBookingOptionsMessage
        data-testid="booking-options-loading"
        aria-live="polite"
        aria-atomic="true"
      >
        <FormattedMessage {...loadingMessage} />
      </LoadingBookingOptionsMessage>
      {isLoading && (
        <LoadingCard role="presentation">
          <ShimmeringLoaderBar height={30} width={100} />
          <DesktopShimmerLoader>
            <ShimmeringLoaderBar height={30} width={100} />
          </DesktopShimmerLoader>
        </LoadingCard>
      )}
    </>
  );
};
